import React from 'react'

const Preview = () => {
  return (
    <div>Pre Defined Templates</div>
  )
}

export default Preview